import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core'
import * as moment from 'moment'
import { FilterUtils } from 'primeng/utils'
import { Table } from 'primeng/table'
import { Subject } from 'rxjs'
import { map, takeUntil } from 'rxjs/operators'
import { AppUsageService } from '../../../../_shared/services/app-usage.service'
import {
  AgrishopTags,
  ASessionInstance,
  SessionInstance,
} from '../../interface'

export interface IDATA {
  name: string
  location: string
  crop: string
  phoneNumber: string
  userId: string
  tag: AgrishopTags
  lastSession: number
  productId: string
  enterprise: string
}

@Component({
  selector: 'app-usage-table',
  templateUrl: './usage-table.component.html',
  styleUrls: ['./usage-table.component.scss'],
})
export class AppUsageTableComponent implements OnInit, OnDestroy {
  limit = 20
  selectedItems = []
  rangeDates: Date[]
  isLoading$ = this.usageState.isLoading$

  cols = [
    { field: 'name', header: 'Name' },
    { field: 'location', header: 'District' },
    { field: 'crop', header: 'Crop' },
    { field: 'phoneNumber', header: 'Phone Number' },
    { field: 'userId', header: 'User Id' },
    { field: 'tag', header: 'Tag' },
    { field: 'productId', header: 'Product Id' },
    { field: 'enterprise', header: 'Customer Type' },
  ]

  @ViewChild('usage') private _table: Table
  usageList: IDATA[] = []
  private unsubscribe$ = new Subject()
  constructor(private usageState: AppUsageService) {}
  ngOnDestroy(): void {
    this.unsubscribe$.next()
    this.unsubscribe$.complete()
  }

  ngOnInit() {
    FilterUtils['dateRangeFilter'] = (value, filter): boolean => {
      if (
        filter === undefined ||
        filter === null ||
        filter[0] === undefined ||
        filter[0] === null
      ) {
        return true
      }

      if (value === undefined || value === null) {
        return false
      }

      if (filter[1] === undefined || filter[1] === null) {
        return moment(value) >= moment(filter[0])
      }
      return (
        moment(value) >= moment(filter[0]) &&
        moment(value) <= moment(filter[1]).add(23.9999, 'hours')
      )
    }

    this.usageState.filteredRecords$
      .pipe(
        takeUntil(this.unsubscribe$),
        map((data) => {
          return data.map((point) => {
            let lastSession: SessionInstance<AgrishopTags>
            try {
              lastSession = point.sessions[0].sort(
                (a, b) => b.timestamp - a.timestamp
              )[0]
            } catch (error) {
              lastSession = new ASessionInstance()
            }
            return {
              name: point.info.name,
              location: point.info.location,
              crop: point.info.crop,
              phoneNumber: point.info.phoneNumber,
              userId: point.info.userId,
              enterprise: point.info.enterprise,
              tag: lastSession.tag,
              lastSession: lastSession.timestamp,
              productId: lastSession.productId,
            }
          })
        })
      )
      .subscribe((data) => {
        this.usageList = data.sort((a, b) => b.lastSession - a.lastSession)
      })
  }

  public get exportName(): string {
    return (
      'Usage Download ' + new Date().toJSON().slice(0, 10).replace(/-/g, '/')
    )
  }

  filterByDate(event) {
    this._table.filter(this.rangeDates, 'lastSession', 'dateRangeFilter')
  }
}
